import React, { useMemo } from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import PreviewCardsGallery from 'components/UI/PreviewCardsGallery';
import Button from 'components/UI/Button';
import Alert from 'components/UI/Alert';
import ProjectGalleryCard from 'components/cards/ProjectGalleryCard';
import { pushCustomEvent } from 'utils/analytics';
import { useLang, useTrans } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { projectsGridConfig } from 'components/Cases/constans';
import { useTopCompanies } from 'staticQueries/top-companies-info';

import * as styles from './TopProjects.module.scss';

function TopProjects({ title }) {
  const t = useTrans(['latestProjects', 'common']);
  const lang = useLang();
  const { projects, casesAmount } = useTopCompanies();

  const navItems = useMemo(() => projects?.map(item => item.project_url), [projects]);

  const alertButtonName =
    lang === 'ae' ? `(${casesAmount}) ${t('seeAll')}` : `${t('seeAll')} (${casesAmount})`;

  const handleClick = () => {
    pushCustomEvent('ndrsn_projects_block', {
      action: 'click_on_button',
      label: 'cta_projects',
    });
  };

  return (
    <Container id="concepts-list">
      <div className={styles.wrapper}>
        <Title tag="h2">{title}</Title>
        <PreviewCardsGallery
          CardComponent={ProjectGalleryCard}
          items={projects}
          navItems={navItems}
          gridConfig={projectsGridConfig}
          pageSize={4}
          layout="projects"
        />
        <Alert
          theme="largeWithText"
          fontSize="lg"
          icon={null}
          markupContent={t('alert')}
          Button={
            <Button
              tag="a"
              href={t('alertUrl')}
              onClick={handleClick}
              target="_blank"
              fullWidthMobile
            >
              {alertButtonName}
            </Button>
          }
        />
      </div>
    </Container>
  );
}

TopProjects.displayName = 'TopProjects';

export default withErrorBoundary(TopProjects);
